import {
  FuelCompositionActions,
  SetFormItemValueAction,
  SetFormDataAction,
  SetPendingAction,
  FormActionTypes,
} from "./FuelComposition.actions";
import { initialState } from "../initialState";
import { FuelCompositionState, FormItem } from "models";
import { validateValue, validateFormData, calculateOxygenValue } from "utils/form.utils";

const setFormData = (state: FormItem[], action: SetFormDataAction | SetFormItemValueAction): FormItem[] => {
  switch (action.type) {
    case FuelCompositionActions.SetFormData:
      return calculateOxygenValue(validateFormData((action as SetFormDataAction).payload));
    case FuelCompositionActions.SetFormItemValue:
      return calculateOxygenValue(validateValue(state, action.payload.id, action.payload.value));
    default:
      return state;
  }
};

const setSubmitPending = (state: boolean, action: SetPendingAction): boolean => {
  switch (action.type) {
    case FuelCompositionActions.SetSubmitFailed:
    case FuelCompositionActions.SetSubmitSuccessful:
      return false;
    case FuelCompositionActions.SetSubmitPending:
      return action.payload;
    default:
      return state;
  }
};

export const formReducer = (state: FuelCompositionState = initialState.fuelComposition, action: FormActionTypes): FuelCompositionState => {
  return {
    submitPending: setSubmitPending(state.submitPending, action as SetPendingAction),
    data: setFormData(state.data, action as SetFormDataAction | SetFormItemValueAction),
  };
};
